export const GENDERS={0: "Male", 1: "Female"}
export const EMPLOYMENT={0: "Any", 1: "Full-time", 2: "Part-time", 3: "Casual employment", 4: "Contract employment", 5: "Apprenticeship", 6: "Traineeship", 7: "Employment on commission", 8: "Probation"}
export const RELOCATION = {0: "Yes", 1: "No"}